import React from 'react';
import {
  DataGrid,
  GridColDef,
  GridRowSelectionModel,
} from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { IMapActivity } from './activitymap.models';

type Props = {
  rows: IMapActivity[];
  selection: GridRowSelectionModel;
  onSelectionChange: (selection: GridRowSelectionModel) => void;
};

const emptySelection: GridRowSelectionModel = {
  type: 'include',
  ids: new Set(),
} as GridRowSelectionModel;

export default class ActivityMapActivityGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'shortcode', headerName: 'Activity Code', width: 140 },
    { field: 'recname', headerName: 'Activity', flex: 1, minWidth: 300 },
    { field: 'costcentercode', headerName: 'CC', width: 110 },
    { field: 'drivercount', headerName: 'Drivers', width: 90, type: 'number' },
    { field: 'allocationcount', headerName: 'Links', width: 90, type: 'number' },
    { field: 'allocatedamount', headerName: 'Allocated', width: 130, type: 'number' },
    { field: 'allocationstatus', headerName: 'Status', width: 130 },
  ];

  render() {
    return (
      <Box sx={{ height: 520 }}>
        <DataGrid
          rows={this.props.rows || []}
          columns={this.columns}
          getRowId={(row) => row.recid}
          checkboxSelection
          disableRowSelectionOnClick
          rowSelectionModel={this.props.selection || emptySelection}
          onRowSelectionModelChange={this.props.onSelectionChange}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
        />
      </Box>
    );
  }
}